// 标签常量 - 用于模型的 tags 属性
const TAGS = {
    // 分辨率标签
    P720: '720p',
    P1080: '1080p',
    P768: '768p',
    K1: '1K',
    K2: '2k',
    K4: '4k',

    // 功能特性标签
    KEYFRAMES: 'keyframes',
    SHOTS: 'shots',
    AUDIO: 'audio',
    REFERENCE: 'reference',
    TEXT_PROMPT: 'text_prompt',
    FAST: 'fast',
    CINEMATIC: 'cinematic',
    ACTION_SMOOTH: 'action_smooth',
    ACTIONS_PRECISION: 'actions_precision',
    EXPRESSION_CONTROL: 'expression_control',
    // 过滤器标签
    ALL: 'all',
};

// 分类常量 - 用于模型的 categorys/categoryByMode 属性
// 值与 TAGS 相同，但语义上用于分类而非标签
const CATEGORIES = {
    // 分辨率分类
    P720: '720p',
    P1080: '1080p',
    P768: '768p',
    K1: '1K',
    K2: '2k',
    K4: '4k',

    // 功能特性分类
    KEYFRAMES: 'keyframes',
    SHOTS: 'shots',
    AUDIO: 'audio',
    REFERENCE: 'reference',
    TEXT_PROMPT: 'text_prompt',
    FAST: 'fast',
    CINEMATIC: 'cinematic',
    ACTION_SMOOTH: 'action_smooth',

    // 过滤器分类
    ALL: 'all',
};

export { TAGS, CATEGORIES };
export default { TAGS, CATEGORIES };
